import { render, staticRenderFns } from "./MarerialDeptSelect.vue?vue&type=template&id=983d7794&"
import script from "./MarerialDeptSelect.vue?vue&type=script&lang=js&"
export * from "./MarerialDeptSelect.vue?vue&type=script&lang=js&"
import style0 from "./MarerialDeptSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VChip,VDivider,VSelect,VTextField})
